import { Outlet } from 'react-router';
import { AppShell } from './AppShell';

export function MainLayout() {
  return (
    <AppShell>
      <Outlet />
    </AppShell>
  );
}
